import computerRequestElements from './vehicle-request-elements'
import vehicleKendoWindow from "./vehicle-kendo-window";
import createCapexRequestController from "../shared/capex-request-controller";

const controller = createCapexRequestController({
    baseUrl: '/Finance/CapExVehicleRequest',
    submitAction: 'SubmitVehicleRequest',
});

export const {
    getApprovalFormData,
    setApprovalControlsBusy,
    approveRequest,
    rejectRequest,
    approvalEvent,
    rejectionEvent,
} = controller;

export default function () {
    computerRequestElements();
    controller.init();
    vehicleKendoWindow();
}
